<template>
<div class="chapter">
<div class="inner_page">
<p class="fm_m">O body swayed to music, O brightening glance, How can we know the dancer from the dance?</p>
<p class="fm_m2"><span class="small">W. B. YEATS,</span> ‘Among School Children’</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Fm2.vue?3a261298